import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-import-export",
  templateUrl: "./med-icon-import-export.component.html",
})
export class MedIconImportExportComponent extends SvgMixinComponent {}
